var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ModalFullScreen", {
        attrs: { withBgClickEvent: true, size: "MB" },
        on: {
          close: function ($event) {
            return _vm.$emit("close")
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "header",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex justify-between bg-white pr-4 sm:pr-6 sm:p-2 pl-0",
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "text-lg leading-6 font-medium text-gray-900",
                        },
                        [_vm._v(" " + _vm._s(_vm.title) + " ")]
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticClass:
                        "cursor-pointer flex items-center justify-center absolute top-2 right-3",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_c("CrossIcon", { staticClass: "h-3.5 w-3.5" })],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "bg-white px-4 py-5 border-gray-200" },
                    [
                      _c(
                        "form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.handleSubmit.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._t("default")],
                        2
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "flex pt-3" },
                    [
                      _vm._t("actions", function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "flex w-full justify-end" },
                            [
                              _c("UIButton", {
                                staticClass: "mr-3",
                                attrs: {
                                  buttonText: "Cancel",
                                  variant: "outline",
                                  size: "lg",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("close")
                                  },
                                },
                              }),
                              _c("UIButton", {
                                attrs: {
                                  buttonText: "Add",
                                  variant: "black",
                                  size: "lg",
                                  disabled: _vm.saveDisabled,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("add")
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }